import { visit } from "unist-util-visit";
import type { Root } from "mdast";

/**
 * Turns `::example-card`, `::example-strategy-page`, `::example-portfolio-builder` and
 * `::example-portfolio-tracker` into the worked examples they name.
 *
 * Directives rather than images, because the thing being explained is live UI: a screenshot would
 * bake in one theme and go stale the next time the page changes, which is exactly what the
 * authoring guide rules out for our own screens.
 */
interface DirectiveNode {
  type: string;
  name?: string;
  data?: {
    hName?: string;
    hProperties?: Record<string, unknown>;
  };
}

const ELEMENTS: Record<string, string> = {
  "example-card": "help-example-card",
  "example-strategy-page": "help-example-strategy-page",
  "example-portfolio-builder": "help-example-portfolio-builder",
  "example-portfolio-tracker": "help-example-portfolio-tracker",
};

export function remarkExampleCard() {
  return (tree: Root) => {
    visit(tree, (node) => {
      const directive = node as DirectiveNode;
      if (
        directive.type !== "leafDirective" &&
        directive.type !== "containerDirective"
      ) {
        return;
      }
      const element = ELEMENTS[directive.name ?? ""];
      // An unrecognised directive is left alone rather than swallowed — it renders as plain text,
      // which is visible in review.
      if (!element) return;

      directive.data = { ...directive.data, hName: element, hProperties: {} };
    });
  };
}
